export const BaseDialog = ({ 
  isOpen, 
  onClose,
  showClose,
  title,
  t,
  children, 
  size = 'md',
}) => {
  if (!isOpen) return null;

  const sizeClasses = {
    sm: 'modal-sm',
    md: '',
    lg: 'modal-lg',
    xl: 'modal-xl'
  };

  return (
    <>
      {/* Backdrop */}
      <div 
        className="modal-backdrop show"
        onClick={onClose}
      />
      
      {/* Dialog */}
      <div 
        className="modal show d-block" 
        tabIndex="-1"
        onClick={(e) => e.stopPropagation()}
      >
        <div className={`modal-dialog ${sizeClasses[size]} modal-dialog-centered`}>
          <div className="modal-content position-relative">

            {/* Header without close button */}
            {title && (
              <div className="modal-header">
                <h5 className="modal-title">{title}</h5>
              </div>
            )}

            {/* Content */}
            <div className="modal-body">
              {children}
            </div>
            
            {showClose && (
                <>
                  <div className="modal-footer">
                    <div className="d-flex justify-content-end gap-2 pt-3 border-top">
                      <button type="button" className="btn btn-outline-secondary" onClick={onClose}>{t('buttons.close')}</button>
                    </div>
                  </div>
                </>
            )}
          </div>
        </div>
      </div>
    </>
  );
};